export function onReceive(cb){
    window.networkWorker.onmessage = e => {
        cb(e);
    }
    
}

export function send(payload){
    window.networkWorker.postMessage({chunkSize: 25, payload});
}